<template>
  <div class="tbe-app">
    <div v-if="!appLoading && !initDataError" class="tbe-app__body">
      <keep-alive>
        <component v-bind:is="currentView"></component>
      </keep-alive>
    </div>

    <tbe-alert group="info" />
    <tbe-alert group="error" />
  </div>
</template>

<script>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  import tbeAlert from 'common/plugins/rs-alert'

  import tbeMainView from '@/views/tbeMainView'
  import tbeOrderView from '@/views/tbeOrderView'
  import tbeFinalOrderView from '@/views/tbeFinalOrderView'

  import { VIEWS } from '@/config'

  export default {
    name: 'App',

    components: { tbeMainView, tbeAlert },

    props: {
      productId: [String, Number],
      defaultOptionId: [String, Number],
      locale: String
    },

    setup(props) {
      const store = useStore()

      const productId = Number(props.productId) || -1
      const locale = props.locale || 'en'
      const defaultOptionId = Number(props.defaultOptionId) || -1

      const settingsLoading = computed(() => store.state.app.settingsLoading)
      const initDataLoading = computed(() => store.state.booking.initDataLoading)
      const initDataError = computed(() => store.state.booking.initDataError)

      const setLocale = (payload) => store.dispatch('app/setLocale', payload)
      const setProductId = (payload) => store.dispatch('app/setProductId', payload)
      const setDefaultOptionId = (payload) => store.dispatch('app/setDefaultOptionId', payload)

      const fetchSettings = (payload) => store.dispatch('app/fetchSettings', payload)
      const fetchInitData = () => store.dispatch('booking/fetchInitData', { productId })

      const appLoading = computed(() => settingsLoading.value || initDataLoading.value)

      const view = computed(() => store.state.app.view)
      const currentView = computed(() => {
        if (view.value === VIEWS.MAIN) return tbeMainView
        else if (view.value === VIEWS.ORDER) return tbeOrderView
        else if (view.value === VIEWS.FINAL_ORDER) return tbeFinalOrderView
        return tbeMainView
      })

      async function init() {
        try {
          await setLocale(locale)

          await setProductId(productId)
          await setDefaultOptionId(defaultOptionId)

          await Promise.all([fetchSettings(), fetchInitData()])
        } catch (e) {
          console.log(e)
        }
      }

      init()

      return { appLoading, initDataError, currentView }
    }
  }
</script>

<style src="vue-tel-input/dist/vue-tel-input.css"></style>

<style lang="scss">
  @import 'scss/fonts';
  @import 'scss/common';

  .tbe-app {
    &__body {
    }
  }
</style>
